import { FILES_URL } from '@/shared/lib/utils/constants/const'

export const selectList = [
	{
		placeholder: `Модель`,
		items: [
			{
				value: `iPhone 2`,
				title: ``
			},
			{
				value: `iPhone 15`,
				title: ``
			}
		]
	},
	{
		placeholder: `Год`,
		items: [
			{
				value: `iPhone 2`,
				title: ``
			},
			{
				value: `iPhone 15`,
				title: ``
			}
		]
	},
	{
		placeholder: `SSD`,
		items: [
			{
				value: `iPhone 2`,
				title: ``
			},
			{
				value: `iPhone 15`,
				title: ``
			}
		]
	},
	{
		placeholder: `Диагональ`,
		items: [
			{
				value: `iPhone 2`,
				title: ``
			},
			{
				value: `iPhone 15`,
				title: ``
			}
		]
	},
	{
		placeholder: `ОЗУ`,
		items: [
			{
				value: `iPhone 2`,
				title: ``
			},
			{
				value: `iPhone 15`,
				title: ``
			}
		]
	},
	{
		placeholder: `TouchFace`,
		items: [
			{
				value: `iPhone 2`,
				title: ``
			},
			{
				value: `iPhone 15`,
				title: ``
			}
		]
	}
]

export const heroInfoDataUr = {
	imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/trade-in/hero.png`,
	title: `Обмен в Трейд-ин для бизнеса`,
	subtitle: `Меняйтесь с лёгкостью. Обновите свой корпоративный парк техники Apple с дополнительной выгодой и работайте эффективнее.`,
	items: [
		{
			title: `Юридическая чистота`,
			description: `Выдаём акт оценки, договор, отгрузочные документы.`
		},
		{
			title: `Выгодные условия`,
			description: `Для юридических лиц действуют повышенные цены выкупа устройств.`
		},
		{
			title: `Удобная доставка`,
			description: `Заберём технику на диагностику и привезём обратно к вам в офис новые устройства.`
		}
	]
}

export const faqItemsUr = [
	{
		question: `Какие документы выдаёте?`,
		answer: `Выдаём акт оценки, договор, отгрузочные документы.`
	},
	{
		question: `Сколько по времени диагностика?`,
		answer: `Время полной диагностики одного iOS или iPadOS устройства в среднем 30-40 минут, одного macOS устройства – 2-3 часа.`
	},
	{
		question: `Куда нужно принести технику?`,
		answer: `В наши сервисные центры iPort. Адреса сервисных центров можно посмотреть на <a href="/shops/" title="К списку магазинов">карте</a>.`
	},
	{
		question: `В каком состоянии принимаете устройства?`,
		answer: `Техника должна быть в рабочем состоянии без существенных внешних повреждений корпуса и экрана, с работающими кнопками, без признаков повреждений от контакта с водой. C устройства должна быть снята защита FMI. Устройство должно быть приобретено на территории Евразийского экономического союза у юридического лица — официального дистрибьютора продукции Apple или торгового партнёра компании Apple (информация о соответствующих дистрибьюторах и торговых партнёрах размещена на сайте https://www.apple.com/ru/).
`
	},
	{
		question: `Можно сдать устройство в нерабочем состоянии?`,
		answer: `Выкуп устройства в нерабочем состоянии согласовывается индивидуально с менеджером после диагностики.`
	},
	{
		question: `Если я сдаю несколько устройств, как это оформляется?`,
		answer: `Каждое устройство оформляется отдельно. При этом стоимость всех устройств можно объединить и получить скидку на новое оборудование, равную сумме всех старых.`
	},
	{
		question: `Как определяется цена устройства?`,
		answer: `Цена определяется в зависимости от визуального и технического состояния устройства.`
	},
	{
		question: `Обмен в Трейд-ин суммируется с другими акциями?`,
		answer: `На новые устройства, приобретаемые со скидкой по программе обмен в Трейд-ин, распространяются все акции и специальные предложения с обязательной пометкой на сайте, что акция действительна для юридических лиц.`
	},
	{
		question: `Что делать, если новое устройство стоит больше скидки по обмен в Трейд-ин?`,
		answer: `Если стоимость нового устройства выше предоставленной скидки, недостающую сумму можно доплатить по счёту, выставленному тому же юридическому лицу. Допускается покупка сопутствующих товаров.`
	}
]

export const stepsList = [
	{
		title: `В магазине`,
		items: [
			{
				value: `Выберите новое устройство на сайте и оформите самовывоз, либо сразу обратитесь в магазин.`
			},
			{
				value: `.Отдайте старое устройство нашему специалисту на диагностику.`
			},
			{
				value: `Используйте итоговую стоимость выкупа при покупке нового устройства. Можно в рассрочку.`
			}
		]
	}
]

export const pdfListUr = [
	{
		title: `Оферта обмен в Трейд-ин B2B`,
		link: `${FILES_URL}/files/pdf/b2b/trade-in/Условия_акции_Trade-in_для_B2B_клиентов.pdf`
	}
]

export const stepsItemsUr = [
	{
		subtitle: `Оставьте заявку на сайте. В ней укажите серийный номер техники, которую планируете сдать, её состояние, комплектность (коробка, чек, зарядка и пр.). Получите предварительный расчёт.`
	},
	{
		subtitle: `Сдайте технику на диагностику в<a href="https://www.iport.ru/service/" title="К сервисным центрам" target="_blank"> сервисный центр iPort</a>, чтобы узнать точную стоимость. Можете привезти лично или заказать забор техники курьером.`
	},
	{
		subtitle: `Получите акт оценки стоимости оборудования. Эта сумма и есть ваша выгода на новое устройство.`
	},
	{
		subtitle: `Обменяйтесь с нами документами.`
	},
	{
		subtitle: `Используйте стоимость выкупа при покупке нового устройства.`
	}
]

export const tradeInModalCheckboxes = [
	{
		formName: `turnsOnAndCharging`,
		name: `Устройство включается и заряжается`,
		description: ``,
		tooltip: ``
	},
	{
		formName: `everythingWork`,
		name: `Все основные функции работают исправно?`,
		description: ``,
		tooltip: ``
	},
	{
		formName: `displayNoDamaged`,
		name: `Корпус и дисплей не имеют критических повреждений`,
		description: ``,
		tooltip: `На устройстве имеются минимальные следы использования, несколько поверхностных царапин и незначительные потертости на корпусе`
	},
	{
		formName: `warranty`,
		name: `Имеется гарантия от производителя`,
		description: `Устройство куплено в официальном магазине и активировано менее года назад`,
		tooltip: ``
	}
]

export const tradeInConditionItems = [
	{
		conditionName: `Идеальное`,
		value: `perfect`,
		description: `Без следов использования`
	},
	{
		conditionName: `Отличное`,
		value: `great`,
		description: `Есть незначительные царапины или потёртости`
	},
	{
		conditionName: `Хорошее`,
		value: `good`,
		description: `Многочисленные царапины на корпусе или дисплее`
	},
	{
		conditionName: `Удволетворительное`,
		value: `alright`,
		description: `Имеются сколы или вмятины на корпусе или дисплее`
	}
]

export const AdvLineData = {
	title: `iPort+`,
	subtitle: `Получите дополнительную выгоду до 30% на карту преимуществ iPort+ при условии сдачи своего устройства в обмен в Трейд-ин.
`,
	link: `/services/plus/`,
	buttonText: `Подробнее о карте iPort+`,
	image: {
		src: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/common/iport/iport-card.png`,
		width: 422,
		height: 263
	},
	withRedirectLink: true,
	redirectLink: `/services/plus/`,
	backgroundColor: `#D4E2FC`
}
